import React, { useState } from "react";
import { FaCopy, FaCheck } from "react-icons/fa";
import { cn } from "../../../../util/lib";

export const CopyButton = ({
  text,
  label = "",
  className = "",
  iconOnly = true,
  title = "คลิกเพื่อคัดลอก",
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = async (e) => {
    e.stopPropagation();
    if (!text) return;
    try {
      await navigator.clipboard.writeText(String(text));
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  if (!text) return null;

  return (
    <button
      type="button"
      onClick={handleCopy}
      title={title}
      className={cn(
        "inline-flex items-center justify-center gap-1.5 px-2 py-1 text-xs font-semibold rounded-md transition-all shadow-xs select-none cursor-pointer",
        copied
          ? "bg-emerald-100 text-emerald-700 border border-emerald-300"
          : "bg-slate-100 hover:bg-slate-200 text-slate-700 border border-slate-300 active:scale-95",
        className
      )}
    >
      {copied ? (
        <>
          <FaCheck className="text-emerald-600 text-[11px]" />
          {!iconOnly && <span>คัดลอกแล้ว</span>}
        </>
      ) : (
        <>
          <FaCopy className="text-slate-500 text-[11px]" />
          {label && <span>{label}</span>}
        </>
      )}
    </button>
  );
};
